module.exports = __webpack_public_path__ + "static/media/hidden.3c29cf1f.png";